import {
    IFormField, IFormSection,
    PickListItem, JsonItem,
    TextInputField, TextInputOptions,
    DropdownInputField, DropdownInputOptions,
    NumberInputField, NumberInputOptions,
    MultiAddInputField, MultiAddInputOptions
} from "../../../../../shared/components/web-form/web-form.objects";
import { BiospecimenRequest, StudyGroup, UserQuery, } from "../../scripts/request-form.objects";
import { BiospecimenInventoryLookup } from "../../../inventory-summary/scripts/inventory-lookup";
import _ from "lodash";

export class SpecimenRequestInputOptions {
    modalId: string;
    studyGroups: StudyGroup[];
    userQueries: UserQuery[];

    constructor(modalId: string, studyGroups: StudyGroup[], userQueries: UserQuery[]) {
        this.modalId = `#${modalId}`;
        this.studyGroups = studyGroups;
        this.userQueries = userQueries;
    }
}

export class SpecimenRequestInputField implements IFormField {
    fieldId: string;
    displayName: string;
    isRequired: boolean;
    propertyName: string;
    defaultVal: any;
    formSection: IFormSection;
    forObjProperty: boolean = true;
    shouldTriggerUpdate: boolean = false;

    options: SpecimenRequestInputOptions;

    modalFormFields: IFormField[];
    storedRequests: BiospecimenRequest[];
    currentRequestIndex: number;

    constructor(propertyName: string, defaultVal: any, fieldId: string, displayName: string, isRequired: boolean, options: SpecimenRequestInputOptions) {
        this.fieldId = fieldId;
        this.displayName = displayName;
        this.isRequired = isRequired;
        this.propertyName = propertyName;
        this.defaultVal = defaultVal;

        this.options = options;
    }

    initialize(formSection: IFormSection) {
        this.formSection = formSection;

        this.storedRequests = [];
        this.currentRequestIndex = -99;

        this.generateHtml();
        this.initializeFormFields();
        this.initializeAddBtn();
        this.initializeSaveModalBtn();
        this.drawGallery();
    }

    initializeFormFields() {
        let queryPickList: PickListItem[] = [];
        this.options.userQueries.forEach(query => {
            queryPickList.push({
                Id: query.Id,
                Value: query.QueryName
            });
        });

        let clinicalTrialPicklist = this.generatePickListFromLookup("trial");

        let clinicalTrialInput = new DropdownInputField("ClinicalTrialId", 0, "sample-clinicalTrial", "Clinical Trial", true, new DropdownInputOptions(false, clinicalTrialPicklist));
        let biospecimenTypeInput = new DropdownInputField("BiospecimenTypeId", 0, "sample-type", "Biospecimen Type", true);
        let treatmentArmInput = new DropdownInputField("TreatmentArmId", 0, "sample-treatment-arm","Treatment Arm", true, new DropdownInputOptions(false, []));
        let symptomClusterInput = new DropdownInputField("SymptomClusterId", 0, "sample-symptom-cluster", "Symptom Cluster", true, new DropdownInputOptions(false, []));
        let visitInput = new DropdownInputField("VisitIds", 0, "sample-visit", "Visit(s)", true, new DropdownInputOptions(true, [], false));
        let numberSpecimenInput = new NumberInputField("Quantity", "", "sample-quantity", "Number of Biospecimens Requested per Visit", true, new NumberInputOptions(false, 0));
        let amountSpecimenInput = new NumberInputField("Volume", "", "sample-volume", "Amount per Biospecimen", true, new NumberInputOptions(false, 0));
        //let unitInput = new DropdownInputField("UnitId", 0, "sample-units", "Unit", true, new DropdownInputOptions(false, []));
        let queryInput = new MultiAddInputField("QueryIds", "", "sample-queries", "Inventory Search Queries", true, new MultiAddInputOptions("No Search Queries Added", true, queryPickList));

        this.modalFormFields = [
            clinicalTrialInput,
            biospecimenTypeInput,
            treatmentArmInput,
            symptomClusterInput,
            visitInput,
            numberSpecimenInput,
            amountSpecimenInput,
            //unitInput,
            queryInput
        ];

        queryInput.initialize(null);

        clinicalTrialInput.generateDropdown();

        //let controlledDropdowns = [biospecimenTypeInput, treatmentArmInput, symptomClusterInput, visitInput, unitInput];
        let controlledDropdowns = [biospecimenTypeInput, treatmentArmInput, symptomClusterInput, visitInput];
        controlledDropdowns.forEach(dropdown => dropdown.generateDropdown());

        controlledDropdowns.forEach(dropdown => dropdown.setDisabled(true));
        controlledDropdowns.forEach(dd => $(`#${dd.fieldId}`).selectpicker?.('refresh'));

        $(`#${clinicalTrialInput.fieldId}`).on("change", () => {
            controlledDropdowns.forEach(dropdown => dropdown.setDisabled(true));

            const currentTrialId: number = clinicalTrialInput.getValue();

            if (!currentTrialId || currentTrialId === 0) {
                biospecimenTypeInput.setOptions([]);
                treatmentArmInput.setOptions([]);
                symptomClusterInput.setOptions([]);
                visitInput.setOptions([]);

                controlledDropdowns.forEach(dd => $(`#${dd.fieldId}`).val("").trigger("change"));
                $(`#${visitInput.fieldId}`).selectpicker('refresh');

                this.setUnitMeasureDefaultUnits();
                return;
            }

            const biospecimenPickList = this.generatePickListFromLookup("biospecimen-type", currentTrialId);
            const treatmentArmPickList = this.generatePickListFromLookup("treatment", currentTrialId);
            const symptomClusterPickList = this.generatePickListFromLookup("symptom-cluster", currentTrialId);
            const visitPickList = this.generatePickListFromLookup("collection-window", currentTrialId);

            biospecimenTypeInput.setOptions(biospecimenPickList);
            treatmentArmInput.setOptions(treatmentArmPickList);
            symptomClusterInput.setOptions(symptomClusterPickList);
            visitInput.setOptions(visitPickList);

            $(`#${visitInput.fieldId}`).selectpicker('refresh');

            this.setUnitMeasureDefaultUnits();

            controlledDropdowns.forEach(dropdown => dropdown.setDisabled(false));
        });

        $(`#${biospecimenTypeInput.fieldId}`).on("change", () => {
            const sampleTypeId: number = biospecimenTypeInput.getValue();

            if (!sampleTypeId || sampleTypeId === 0) {
                this.setUnitMeasureDefaultUnits();
                return;
            }
            const unitMeasureId = this.getUnitMeasureIdFromSampleTypeId(sampleTypeId);
            const unitMeasureLabel = BiospecimenInventoryLookup.GetValueFromIdAndType(unitMeasureId, "unit-measure");
            $("#sample-units").val(String(unitMeasureId));
            $("#sample-unit-measure-addon").text(unitMeasureLabel);
        });
    }

    private generatePickListFromLookup(type: string, trialId: number = 0): PickListItem[] {
        let pickList: PickListItem[] = [];
        if (type == "trial") {
            this.options.studyGroups.forEach(group => {
                let foundVal = BiospecimenInventoryLookup.GetValueFromIdAndType(group.StudyId, "study");
                if (foundVal != "Unknown") {
                    pickList.push({
                        Id: group.StudyId,
                        Value: foundVal
                    });
                }
            });
        }
        else if (type == "biospecimen-type") {
            if (trialId != 0) {
                let studyGroup = this.options.studyGroups.find(group => group.StudyId == trialId);
                if (studyGroup) {
                    studyGroup.SpecimenTypeIds.forEach(specimentype => {
                        let foundVal = BiospecimenInventoryLookup.GetValueFromIdAndType(specimentype, "sample-type");
                        if (foundVal != "Unknown") {
                            pickList.push({
                                Id: specimentype,
                                Value: foundVal
                            });
                        }
                    })
                }
            }
        }
        else if (type == "treatment") {
            if (trialId != 0) {
                let studyGroup = this.options.studyGroups.find(group => group.StudyId == trialId);
                if (studyGroup) {
                    studyGroup.TreatmentIds.forEach(treatment => {
                        let foundVal = BiospecimenInventoryLookup.GetValueFromIdAndType(treatment, "treatment");
                        if (foundVal != "Unknown") {
                            pickList.push({
                                Id: treatment,
                                Value: foundVal
                            });
                        }
                    })
                }
            }
        }
        else if (type == "collection-window") {
            if (trialId != 0) {
                let studyGroup = this.options.studyGroups.find(group => group.StudyId == trialId);
                if (studyGroup) {
                    studyGroup.VisitIds.forEach(visit => {
                        let foundVal = BiospecimenInventoryLookup.GetValueFromIdAndType(visit, "collection-window");
                        if (foundVal != "Unknown") {
                            pickList.push({
                                Id: visit,
                                Value: foundVal
                            });
                        }
                    })
                }
            }
        }
        else if (type == "symptom-cluster") {
            if (trialId != 0) {
                let studyGroup = this.options.studyGroups.find(group => group.StudyId == trialId);
                if (studyGroup) {
                    studyGroup.SymptomClusterIds.forEach(symptomcluster => {
                        let foundVal = BiospecimenInventoryLookup.GetValueFromIdAndType(symptomcluster, "symptom-cluster");
                        if (foundVal != "Unknown") {
                            pickList.push({
                                Id: symptomcluster,
                                Value: foundVal
                            });
                        }
                    })
                }
            }
        }
        //else if (type == "unit-measure") {
        //    if (trialId != 0) {
        //        let studyGroup = this.options.studyGroups.find(group => group.StudyId == trialId);
        //        if (studyGroup) {
        //            studyGroup.UnitMeasureIds.forEach(unitmeasure => {
        //                let foundVal = BiospecimenInventoryLookup.GetValueFromIdAndType(unitmeasure, "unit-measure");
        //                if (foundVal != "Unknown") {
        //                    pickList.push({
        //                        Id: unitmeasure,
        //                        Value: foundVal
        //                    });
        //                }
        //            })
        //        }
        //    }
        //}

        return pickList;
    }

    generateHtml() {
        let requestGalleryHtml = `
            <div class="biospecimen-request-gallery-container col-12"> 
                <div class="row biospecimen-request-header">
                    <div class="col">
                        Biospecimen Request Number
                    </div>
                    <div class="col-auto gallery-btn-col">
                        Edit
                    </div>
                    <div class="col-auto gallery-btn-col">
                        Remove
                    </div>
                </div>
                <div class="biospecimen-request-gallery">
                    
                </div>
            </div>
        `;

        let addBiospecimenRequestBtnHtml = `
            <div class="mt-4">
                <button class="btn recoverct-blue-btn add-biospecimen-request-btn">+ Add Biospecimen Request</button>
            </div>
        `;

        let html = `
            ${requestGalleryHtml}
            ${addBiospecimenRequestBtnHtml}
        `

        $(`#${this.fieldId}`).empty().html(html);
    }

    private initializeAddBtn() {
        let addBtn = $(`#${this.fieldId}`).find(".add-biospecimen-request-btn");
        addBtn.on('click', () => {
            this.initializeModal();
        });

        // Scroll to top of modal on open
        $(this.options.modalId).on('shown.bs.modal', () => {
            let modalBody = $(this.options.modalId).find(".scroll-modal-body");
            modalBody.animate({
                scrollTop: 0
            }, 200);
        })
    }

    private initializeSaveModalBtn() {
        let saveBtn = $(this.options.modalId).find(".save-biospecimen-modal-btn");
        saveBtn.on('click', () => {
            // Validate
            $(this.options.modalId).find(".modal-validation-msg")
                .addClass("d-none");

            let isValid = this.checkModalValid();

            if (!isValid) {
                $(this.options.modalId).find(".modal-validation-msg").removeClass("d-none");
                return;
            }


            // get updated/new request obj
            let biospecimenRequest = this.getRequestFromModal();

            if (this.currentRequestIndex >= 0) {
                this.storedRequests.splice(this.currentRequestIndex, 1, biospecimenRequest)
            }
            else {
                this.storedRequests.push(biospecimenRequest);
            }
            this.drawGallery();
            $(this.options.modalId).modal('hide');
        })
    }

    private drawGallery() {
        let requestGallery = $(`#${this.fieldId}`).find(".biospecimen-request-gallery");
        requestGallery.empty();

        let content = "";
        if (this.storedRequests.length == 0) {
            content = `
                <div class="row align-items-center">
                    <div class="col biospecimen-nickname-col">
                        No Biospecimen Requests Added
                    </div>
                    <div class="col-auto gallery-btn-col">

                    </div>
                    <div class="col-auto gallery-btn-col">

                    </div>
                </div>
            `;
            requestGallery.append(content);
        }
        else {
            for (let i = 0; i < this.storedRequests.length; i++) {
                let request = this.storedRequests[i];
                content += `
                    <div class="row align-items-center">
                        <div class="col biospecimen-nickname-col">
                            Request ${i + 1}
                        </div>
                        <div class="col-auto gallery-btn-col">
                            <button id="edit-btn-${i}" class="btn gallery-edit-btn">
                                <i class="fa-solid fa-pen-to-square pr-2"></i> Edit
                            </button>
                        </div>
                        <div class="col-auto gallery-btn-col">
                            <button id="delete-btn-${i}" class="btn gallery-delete-btn">
                                <i class="fa-solid fa-trash-can pr-2"></i> Remove
                            </button>
                        </div>
                    </div>
                `
            }
            requestGallery.append(content);

            let biospecimenField = this;
            requestGallery.find(".gallery-edit-btn").on('click', function () {
                let targetId: string = $(this).prop("id");
                let index: number = parseInt(targetId.replace("edit-btn-", ""));
                let foundItem = biospecimenField.storedRequests[index];
                if (foundItem) {
                    biospecimenField.initializeModal(index);
                }
            });

            requestGallery.find(".gallery-delete-btn").on('click', function () {
                let targetId: string = $(this).prop("id");
                let index: number = parseInt(targetId.replace("delete-btn-", ""));
                let foundItem = biospecimenField.storedRequests[index];
                if (foundItem) {
                    biospecimenField.storedRequests.splice(index, 1);
                    biospecimenField.drawGallery();
                }
            })
        }
        this.triggerSectionUpdate();
    }

    private initializeModal(requestIndex: number = -99) {
        this.currentRequestIndex = requestIndex;

        let requestObj: BiospecimenRequest = new BiospecimenRequest();
        let modalTitle = "New Biospecimen Request";

        if (requestIndex >= 0) {
            const foundRequest = this.storedRequests[requestIndex];
            if (foundRequest) {
                modalTitle = "Edit Biospecimen Request";
                requestObj = foundRequest;
            }
        }

        $(this.options.modalId).find(".modal-title").text(modalTitle);

        const clinicalTrialInput = this.modalFormFields.find(f => f.fieldId === "sample-clinicalTrial") as DropdownInputField;
        const biospecimenTypeInput = this.modalFormFields.find(f => f.fieldId === "sample-type") as DropdownInputField;
        const treatmentArmInput = this.modalFormFields.find(f => f.fieldId === "sample-treatment-arm") as DropdownInputField;
        const symptomClusterInput = this.modalFormFields.find(f => f.fieldId === "sample-symptom-cluster") as DropdownInputField;
        const visitInput = this.modalFormFields.find(f => f.fieldId === "sample-visit") as DropdownInputField;

        const controlledDropdowns = [biospecimenTypeInput, treatmentArmInput, symptomClusterInput, visitInput];

        //const trialId =
        //    (requestObj as any).ClinicalTrialId && (requestObj as any).ClinicalTrialId !== 0
        //        ? (requestObj as any).ClinicalTrialId
        //        : parseInt(($(`#sample-clinicalTrial`).val() as string) || "0", 10);

        const trialId =
            requestIndex >= 0
                ? ((requestObj as any).ClinicalTrialId || 0)
                : 0; 

        const setDisabledAndRefresh = (dd: DropdownInputField, disabled: boolean) => {
            dd.setDisabled(disabled);
            $(`#${dd.fieldId}`).prop("disabled", disabled);
            $(`#${dd.fieldId}`).selectpicker?.('refresh');
        };

        controlledDropdowns.forEach(dd => setDisabledAndRefresh(dd, true));

        if (!trialId || trialId === 0) {
            biospecimenTypeInput.setOptions([]);
            treatmentArmInput.setOptions([]);
            symptomClusterInput.setOptions([]);
            visitInput.setOptions([]);

            controlledDropdowns.forEach(dd => $(`#${dd.fieldId}`).val("").trigger("change"));
            $(`#${visitInput.fieldId}`).selectpicker('refresh');

            this.setUnitMeasureDefaultUnits();
        } else {
            biospecimenTypeInput.setOptions(this.generatePickListFromLookup("biospecimen-type", trialId));
            treatmentArmInput.setOptions(this.generatePickListFromLookup("treatment", trialId));
            symptomClusterInput.setOptions(this.generatePickListFromLookup("symptom-cluster", trialId));
            visitInput.setOptions(this.generatePickListFromLookup("collection-window", trialId));

            //controlledDropdowns.forEach(dd => dd.setDisabled(false));
            //controlledDropdowns.forEach(dd => $(`#${dd.fieldId}`).selectpicker?.('refresh'));
            controlledDropdowns.forEach(dd => setDisabledAndRefresh(dd, false));
            this.setUnitMeasureDefaultUnits();
        }

        this.modalFormFields.forEach(field => {
            field.setValue(requestObj);
            field.resetValidDisplay();
        });

        const sampleTypeId = parseInt(($(`#sample-type`).val() as string) || "0", 10);
        if (sampleTypeId) {
            const unitMeasureId = this.getUnitMeasureIdFromSampleTypeId(sampleTypeId);
            const label = BiospecimenInventoryLookup.GetValueFromIdAndType(unitMeasureId, "unit-measure");
            $("#sample-units").val(String(unitMeasureId));
            $("#sample-unit-measure-addon").text(label);
        }

        $(this.options.modalId).modal('show');
    }

    private getRequestFromModal(): BiospecimenRequest {
        let requestObj = new BiospecimenRequest();
        requestObj.BiospecimenRequestName = "";
        this.modalFormFields.forEach(field => {
            _.set(requestObj, field.propertyName, field.getValue());
        });
        
        //requestObj.Quantity = String((requestObj as any).Quantity ?? "");
        requestObj.UnitId = parseInt(($(`#sample-units`).val() as string) || "0", 10);
        return requestObj;
    }

    private removeRequestIds() {
        // removes the Id so each is saved as a new request (delete/add backend)
        this.storedRequests.forEach(request => request.Id = 0);
    }

    private getUnitMeasureIdFromSampleTypeId(sampleTypeId: number): number {
        switch (sampleTypeId) {
            // Plasma + Serum -> microlitres
            case 10: // Plasma - EDTA
            case 1:  // Plasma - Na Hep
            case 2:  // Serum - SST
            case 8:  // Plasma - CPT Na Hep
                return 1;

            // Stool -> units
            case 3: // Stool - OMR-205
            case 4: // Stool - ME-200
                return 3;

            // PBMC -> cells
            case 7: // PBMC - CPT Na Citrate
            case 9: // PBMC - Na Hep
                return 2;

            // Whole Blood -> mass of DNA
            case 5:
                return 4;

            // PAXgene RNA -> mass of RNA
            case 6:
                return 5;

            default:
                return 3; // default units
        }
    }

    private setUnitMeasureDefaultUnits() {
        const defaultUnitId = 3;
        const label = BiospecimenInventoryLookup.GetValueFromIdAndType(defaultUnitId, "unit-measure");
        $("#sample-units").val(String(defaultUnitId));
        $("#sample-unit-measure-addon").text(label);
    }

    getValue(): any {
        let val = this.defaultVal;
        let isValid = this.checkValid();
        let isChanged = this.checkChanged();
        if (isValid && isChanged) {
            this.removeRequestIds();
            val = this.storedRequests;
        }
        return val;
    }

    setValue(formData: any) {
        let formVal = _.get(formData, this.propertyName)
        this.storedRequests = formVal;
        this.removeRequestIds();
        this.drawGallery();
    }

    checkValid(): boolean {
        if (this.storedRequests.length == 0) {
            return false;
        }
        return true;
    }

    private checkModalValid(): boolean {
        let isValid = true
        this.modalFormFields.forEach(field => {
            let fieldValid = field.checkValid();
            if (fieldValid) {
                field.displayValid(true);
            }
            else {
                field.displayValid(false);
                isValid = false;
            }
        })
        return isValid;
    }

    checkChanged(): boolean {
        if (this.storedRequests.length == 0) {
            return false;
        }
        return true;
    }

    displayValid(isValid: boolean) {
        return;
    }

    resetValidDisplay() {
        return;
    }

    triggerSectionUpdate() {
        if (this.formSection && this.shouldTriggerUpdate) {
            this.formSection.updateSection();
        }
    }
}